import { createContext } from 'react';
import { Client } from '../pages/dashboard/Clients/types';

export type ClientsContextType = {
  clients: Client[];
  selectedClient: Client | null;
  addClients: (newClients: Client[], resetClients?: boolean) => void;
  setSelectedClient: (client: Client | null, resetPrevious?: boolean) => void;
  removeClient: (clientId: string | number) => void;
  updateClient: (updatedClient: Client) => void;
};

const defaultClientsContextValue: ClientsContextType = {
  clients: [],
  selectedClient: null,
  addClients: () => {},
  setSelectedClient: () => {},
  removeClient: () => {},
  updateClient: () => {},
};

const ClientsContext = createContext<ClientsContextType>(defaultClientsContextValue);

export default ClientsContext;
